import produce from 'immer';
import React, {useCallback} from 'react';

import {profileLinkAdded} from '../../services/analytics';
import {
  ShowcasedLink,
  useEntityPageContext,
  useEntityPageUpdaterContext,
} from './context';
import {LinkModal} from './LinkModal';

type AddLinkModalProps = {onClose: () => void};

const AddLinkModalComp: React.FC<AddLinkModalProps> = ({onClose}) => {
  const {entityName} = useEntityPageContext();
  const {setLinks} = useEntityPageUpdaterContext();

  const onSubmit = useCallback(
    (l: ShowcasedLink) => {
      profileLinkAdded({entityName, linkName: l.name, linkURL: l.url});
      setLinks(prev =>
        produce(prev, draft => {
          draft.push(l);
        })
      );
    },
    [entityName, setLinks]
  );

  return (
    <LinkModal
      headerText={`Add a link`}
      confirmButtonText={`Add link`}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  );
};

export const AddLinkModal = React.memo(AddLinkModalComp);
